/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import { Popup } from '../popup/index.js';
import useSingle from './useSingle.js';
import useMultiple from './useMultiple.js';
import useOverlayInnerStyle from './useOverlayInnerStyle.js';
import { selectInputDefaultProps } from './defaultProps.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../popup/Popup.js';
import '../_chunks/dep-e43cf21c.js';
import '../_chunks/dep-2acfafca.js';
import 'react-transition-group';
import 'react-popper';
import '../hooks/useControlled.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../_util/noop.js';
import '../_util/useAnimation.js';
import '../hooks/usePrevious.js';
import '../common/Portal.js';
import 'react-dom';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../_util/composeRefs.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../_chunks/dep-4f1e1217.js';
import '../_chunks/dep-ca64038e.js';
import '../_chunks/dep-29cb89ad.js';
import '../_chunks/dep-e73d1b75.js';
import '../_chunks/dep-c8399d32.js';
import '../input/index.js';
import '../input/Input.js';
import '../_chunks/dep-92728dc5.js';
import 'tdesign-icons-react';
import '../_util/useLayoutEffect.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../hooks/useGlobalIcon.js';
import '../input/InputGroup.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../input/defaultProps.js';
import '../_util/parseTNode.js';
import '../input/useLengthLimit.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../input/style/css.js';
import '../input/type.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../tag-input/index.js';
import '../tag-input/TagInput.js';
import '../_util/useDragSorter.js';
import '../tag-input/useTagScroll.js';
import '../tag-input/useTagList.js';
import '../tag/index.js';
import '../tag/Tag.js';
import '../tag/CheckTag.js';
import '../tag/defaultProps.js';
import '../tag/style/css.js';
import '../tag/type.js';
import '../tag-input/useHover.js';
import '../tag-input/defaultProps.js';
import '../tag-input/style/css.js';
import '../tag-input/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SelectInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var _ref;
  var selectInputRef = useRef();
  var selectInputWrapRef = useRef();
  var _useConfig = useConfig(),
    prefix = _useConfig.classPrefix;
  var multiple = props.multiple,
    value = props.value,
    popupVisible = props.popupVisible,
    popupProps = props.popupProps,
    borderless = props.borderless,
    disabled = props.disabled;
  var _useSingle = useSingle(props),
    commonInputProps = _useSingle.commonInputProps,
    inputRef = _useSingle.inputRef,
    singleInputValue = _useSingle.singleInputValue,
    onInnerClear = _useSingle.onInnerClear,
    renderSelectSingle = _useSingle.renderSelectSingle;
  var _useMultiple = useMultiple(props),
    tagInputRef = _useMultiple.tagInputRef,
    multipleInputValue = _useMultiple.multipleInputValue,
    renderSelectMultiple = _useMultiple.renderSelectMultiple;
  var _useOverlayInnerStyle = useOverlayInnerStyle(props, {
      afterHidePopup: onInnerBlur
    }),
    tOverlayInnerStyle = _useOverlayInnerStyle.tOverlayInnerStyle,
    innerPopupVisible = _useOverlayInnerStyle.innerPopupVisible,
    onInnerPopupVisibleChange = _useOverlayInnerStyle.onInnerPopupVisibleChange;
  var popupClasses = classNames([props.className, "".concat(prefix, "-select-input"), (_ref = {}, _defineProperty(_ref, "".concat(prefix, "-select-input--borderless"), borderless), _defineProperty(_ref, "".concat(prefix, "-select-input--multiple"), multiple), _defineProperty(_ref, "".concat(prefix, "-select-input--popup-visible"), popupVisible !== null && popupVisible !== void 0 ? popupVisible : innerPopupVisible), _defineProperty(_ref, "".concat(prefix, "-select-input--empty"), value instanceof Array ? !value.length : !value), _ref)]);
  useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread(_objectSpread({}, selectInputRef.current || {}), inputRef.current || {}), tagInputRef.current || {});
  });
  var visibleProps = {
    visible: popupVisible !== null && popupVisible !== void 0 ? popupVisible : innerPopupVisible
  };
  function onInnerBlur(ctx) {
    var _props$onBlur;
    var inputValue = props.multiple ? multipleInputValue : singleInputValue;
    var params = {
      e: ctx.e,
      inputValue: inputValue
    };
    (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, props.value, params);
  }
  var mainContent = /* @__PURE__ */React.createElement("div", {
    className: popupClasses,
    style: props.style
  }, /* @__PURE__ */React.createElement(Popup, _objectSpread(_objectSpread(_objectSpread({
    ref: selectInputRef,
    trigger: (popupProps === null || popupProps === void 0 ? void 0 : popupProps.trigger) || "click",
    placement: "bottom-left",
    content: props.panel,
    hideEmptyPopup: true,
    onVisibleChange: onInnerPopupVisibleChange,
    updateScrollTop: props.updateScrollTop
  }, visibleProps), popupProps), {}, {
    disabled: disabled,
    overlayInnerStyle: tOverlayInnerStyle
  }), multiple ? renderSelectMultiple({
    commonInputProps: commonInputProps,
    onInnerClear: onInnerClear,
    popupVisible: visibleProps.visible
  }) : renderSelectSingle(visibleProps.visible)));
  if (!props.tips) return mainContent;
  return /* @__PURE__ */React.createElement("div", {
    ref: selectInputWrapRef,
    className: "".concat(prefix, "-select-input__wrap")
  }, mainContent, props.tips && /* @__PURE__ */React.createElement("div", {
    className: "".concat(prefix, "-input__tips ").concat(prefix, "-input__tips--").concat(props.status || "normal")
  }, props.tips));
});
SelectInput.displayName = "SelectInput";
SelectInput.defaultProps = selectInputDefaultProps;

export { SelectInput as default };
//# sourceMappingURL=SelectInput.js.map
